import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Permission, PublicService, Role, UserLogin, WebUserService} from 'web-angular-client';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService
{
    private USER_KEY = 'userLogin';

    constructor(private publicService: PublicService, private webUserService: WebUserService)
    {
    }

    /**
     * Uses basic auth to authenticate user credentials and if authenticated, stores these
     * credentials locally to be validated by subsequent secure routing requests.
     */
    public login(username: string, password: string)
    {
        this.publicService.configuration.password = password;
        this.publicService.configuration.username = username;

        return this.publicService.authenticate().pipe(map((userLogin: UserLogin) =>
        {
            this.setUserLogin(userLogin);
        }));
    }

    public isGuestAdminUser(): boolean
    {
        return this.getUserLogin() !== null && this.getUserLogin().role.name === Role.NameEnum.GUEST_ADMIN;
    }

    public getUserRole(): Role.NameEnum
    {
        return this.getUserLogin().role.name;
    }

    public isAdminUser(): boolean
    {
        return this.getUserLogin() !== null &&
            (this.getUserLogin().role.name === Role.NameEnum.ADMIN ||
                this.getUserLogin().role.name === Role.NameEnum.SUPER_ADMIN);
    }

    public hasPrivilege(permission: string): boolean
    {
        return permission === 'ANONYMOUS' || this.privileges().some(p => p.name === permission);
    }

    public hasRouteAccess(permissions: string[]): boolean
    {
        return permissions.some(p => this.hasPrivilege(p));
    }

    public privileges(): Permission[]
    {
        return this.getUserLogin().role.permissions;
    }

    public getUserLogin(): UserLogin
    {
        return <UserLogin> JSON.parse(sessionStorage.getItem(this.USER_KEY));
    }

    public isLoggedIn(): boolean
    {
        return !!this.getUserLogin();
    }

    /**
     * Will make a RESTful API 'logout' call to the server. This should invalidate any previously existing cached
     * session data, as well as clear any session data from the local browser storage.
     */
    public logout()
    {
        return this.webUserService.logout().pipe(map(() => sessionStorage.clear()));
    }

    public ping()
    {
        return this.publicService.ping();
    }

    public setUserLogin(userLogin: UserLogin)
    {
        sessionStorage.setItem(this.USER_KEY, JSON.stringify(userLogin));
    }
}